import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

const SignUpToContinueActionLink = () => {
  const { formatMessage } = useIntl();
  const showSignUpToContinue = useFlag(LaunchDarklyFlag.ENABLE_SIGNUP_CART_BUTTON_TEXT);
  const { openSignInModal } = useAuthContext();
  const handleSignUpToContinuePress = () => {
    openSignInModal({
      navigateOnSuccessRoute: routes.cart,
    });
  };
  return (
    <ActionButton onPress={handleSignUpToContinuePress} fullWidth>
      {formatMessage({ id: showSignUpToContinue ? 'signUpToContinue' : 'continue' })}
    </ActionButton>
  );
};

export default SignUpToContinueActionLink;
